import { createRoute, redirect } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/',
  beforeLoad: () => {
    throw redirect({ to: '/settings/profile' })
  },
  component: () => null,
})
